export interface AbilityMeta {
    name: string;
    description: string;
}

export const ABILITY_META: { [key: string]: AbilityMeta } = {
    // --- Base / originales ---
    intimidate: {
        name: 'Intimidar',
        description: 'Aterroriza a los enemigos cercanos, reduciendo su ataque.'
    },
    run: {
        name: 'Correr',
        description: 'Aumenta tu velocidad de movimiento temporalmente.'
    },
    awareness: {
        name: 'Conciencia',
        description: 'Detecta enemigos y trampas ocultas a mayor distancia.'
    },
    dualistsmark: {
        name: 'Marca del Duelista',
        description: 'Tu siguiente ataque inflige daño adicional al objetivo.'
    },
    hotshot: {
        name: 'Tiro Certero',
        description: 'Tu siguiente flecha inflige daño crítico garantizado.'
    },
    thickskin: {
        name: 'Piel Gruesa',
        description: 'Aumenta tu defensa temporalmente, reduciendo el daño recibido.'
    },
    precognition: {
        name: 'Precognición',
        description: 'Otorga una probabilidad de esquivar ataques mágicos.'
    },
    secretcalling: {
        name: 'Llamada Secreta',
        description: 'Invoca un hechizo protector que desvía ataques.'
    },

    // --- Guerrero ---
    cargaviolenta: {
        name: 'Carga Violenta',
        description: 'Embiste al objetivo con fuerza, infligiendo daño adicional.'
    },
    furia: {
        name: 'Furia',
        description: 'Cada golpe recibido aumenta tu daño de ataque.'
    },
    gritobatalla: {
        name: 'Grito de Batalla',
        description: 'Aumenta el ataque de todos los aliados cercanos.'
    },
    bloqueoescudo: {
        name: 'Bloqueo de Escudo',
        description: 'Bloquea los próximos ataques entrantes con tu escudo.'
    },
    barrido: {
        name: 'Barrido',
        description: 'Golpea a todos los enemigos que te rodean.'
    },
    vengador: {
        name: 'Vengador',
        description: 'Contraataca automáticamente al recibir daño.'
    },
    segundavida: {
        name: 'Segunda Vida',
        description: 'Al recibir un golpe mortal, resucitas con parte de tu HP.'
    },
    titan: {
        name: 'Titán',
        description: 'Aumenta enormemente tu HP máximo y defensa por un tiempo.'
    },

    // --- Arquero ---
    disparomultiple: {
        name: 'Disparo Múltiple',
        description: 'Lanza varias flechas al objetivo simultáneamente.'
    },
    ojoaguila: {
        name: 'Ojo de Águila',
        description: 'Aumenta el rango de ataque y precisión permanentemente.'
    },
    trampa: {
        name: 'Trampa',
        description: 'Coloca una trampa que daña y ralentiza al enemigo que la active.'
    },
    camuflaje: {
        name: 'Camuflaje',
        description: 'Te vuelves invisible por un tiempo. Atacar cancela el efecto.'
    },
    lluviaflechas: {
        name: 'Lluvia de Flechas',
        description: 'Hace llover flechas en un área, dañando a todos los enemigos.'
    },
    precisionletal: {
        name: 'Precisión Letal',
        description: 'Mayor probabilidad de golpe crítico con ataques a distancia.'
    },
    punteriadivina: {
        name: 'Puntería Divina',
        description: 'Tus ataques ignoran parte de la defensa del enemigo.'
    },
    flechacongelante: {
        name: 'Flecha Congelante',
        description: 'Dispara una flecha que congela al enemigo en su lugar.'
    },
    marcacazador: {
        name: 'Marca del Cazador',
        description: 'Marca a un objetivo, aumentando todo el daño contra él.'
    },
    rafaga: {
        name: 'Ráfaga',
        description: 'Desata un disparo devastador de enorme daño.'
    },

    // --- Mago base ---
    chispaarcana: {
        name: 'Chispa Arcana',
        description: 'Lanza un proyectil mágico rápido al enemigo.'
    },
    escudomenor: {
        name: 'Escudo Menor',
        description: 'Crea una barrera mágica que absorbe daño.'
    },
    meditacion: {
        name: 'Meditación',
        description: 'Regenera maná más rápido fuera de combate.'
    },

    // --- Elementalista ---
    boladefuego: {
        name: 'Bola de Fuego',
        description: 'Lanza una bola de fuego que explota al impactar.'
    },
    rayocongelante: {
        name: 'Rayo Congelante',
        description: 'Dispara un rayo de hielo que congela y daña al objetivo.'
    },
    descargaelectrica: {
        name: 'Descarga Eléctrica',
        description: 'Lanza un relámpago que electrocuta al objetivo.'
    },
    explosionarcana: {
        name: 'Explosión Arcana',
        description: 'Libera una explosión de energía arcana en área.'
    },
    murofuego: {
        name: 'Muro de Fuego',
        description: 'Crea una barrera de llamas que daña a quienes la crucen.'
    },
    meteorito: {
        name: 'Meteorito',
        description: 'Invoca un meteorito del cielo que causa daño masivo.'
    },
    furiaelemental: {
        name: 'Furia Elemental',
        description: 'Aumenta el daño de todos los hechizos elementales.'
    },
    cadenaelectrica: {
        name: 'Cadena Eléctrica',
        description: 'El rayo salta entre varios enemigos cercanos.'
    },
    absorberalma: {
        name: 'Absorber Alma',
        description: 'Roba vida y maná del enemigo al atacar.'
    },
    tormentahelada: {
        name: 'Tormenta Helada',
        description: 'Invoca una tormenta de hielo en área que congela y daña.'
    },
    vorticearcano: {
        name: 'Vórtice Arcano',
        description: 'Crea un vórtice que succiona y daña a los enemigos.'
    },
    novapoder: {
        name: 'Nova de Poder',
        description: 'Aumenta masivamente el poder mágico temporalmente.'
    },
    cataclismo: {
        name: 'Cataclismo',
        description: 'Desata un cataclismo elemental de daño devastador en área.'
    },
    aniquilacion: {
        name: 'Aniquilación',
        description: 'Concentra toda tu energía en un hechizo letal al objetivo.'
    },
    manifestacion: {
        name: 'Manifestación',
        description: 'Tu presencia elemental potencia todos tus hechizos.'
    },

    // --- Sacerdote ---
    curarmenor: {
        name: 'Curar Menor',
        description: 'Restaura una pequeña cantidad de HP al objetivo aliado.'
    },
    escudodelgrupo: {
        name: 'Escudo del Grupo',
        description: 'Protege a todos los aliados cercanos con una barrera mágica.'
    },
    invocarelementalmenor: {
        name: 'Invocar Elemental Menor',
        description: 'Invoca un elemental que lucha a tu lado.'
    },
    purificar: {
        name: 'Purificar',
        description: 'Elimina efectos negativos del objetivo aliado.'
    },
    resurreccion: {
        name: 'Resurrección',
        description: 'Revive a un aliado caído con parte de su HP.'
    },
    curarmayor: {
        name: 'Curar Mayor',
        description: 'Restaura una gran cantidad de HP al objetivo aliado.'
    },
    bendiciondivina: {
        name: 'Bendición Divina',
        description: 'Aumenta todas las estadísticas del grupo temporalmente.'
    },
    invocarelementalmayor: {
        name: 'Invocar Elemental Mayor',
        description: 'Invoca un elemental poderoso de larga duración.'
    },
    aurasagrada: {
        name: 'Aura Sagrada',
        description: 'Emite un aura que regenera HP a los aliados cercanos.'
    },
    barreradivina: {
        name: 'Barrera Divina',
        description: 'Crea una barrera casi impenetrable por un breve tiempo.'
    },
    regeneraciongrupal: {
        name: 'Regeneración Grupal',
        description: 'Regenera HP de todo el grupo gradualmente.'
    },
    refugiosagrado: {
        name: 'Refugio Sagrado',
        description: 'Crea una zona segura donde los aliados no reciben daño.'
    },
    invocarangel: {
        name: 'Invocar Ángel',
        description: 'Invoca un ángel guardián que cura y protege al grupo.'
    },
    milagro: {
        name: 'Milagro',
        description: 'Restaura completamente el HP y maná del objetivo.'
    },
    guardianeterno: {
        name: 'Guardián Eterno',
        description: 'Un espíritu protector reduce permanentemente el daño recibido.'
    }
};
